import type { AdGroup, AdGroupListItem } from "@models/adGroup.model";
import { CommandListEngagementAdGroups } from "./commands/cmdListEngagementAdGroups";
import { CommandCreateAdGroup, type CreateAdGroupPayload } from "./commands/cmdCreateAdGroup";
import { CommandUpdateAdGroup, type UpdateAdGroupPayload } from "./commands/cmdUpdateAdGroup";
import { CommandDeleteAdGroup } from "./commands/cmdDeleteAdGroup";

export class AdGroupService {
  async listAdGroups(engagementId: number): Promise<AdGroupListItem[]> {
    return new CommandListEngagementAdGroups().run(engagementId);
  }

  async createAdGroup(launchId: number, payload: CreateAdGroupPayload): Promise<AdGroup> {
    return new CommandCreateAdGroup().run(launchId, payload);
  }

  async updateAdGroup(launchId: number, adGroupId: number, payload: UpdateAdGroupPayload): Promise<AdGroup> {
    return new CommandUpdateAdGroup().run(launchId, adGroupId, payload);
  }

  async deleteAdGroup(launchId: number, adGroupId: number): Promise<void> {
    return new CommandDeleteAdGroup().run(launchId, adGroupId);
  }
}
